const module_name = "service.default-date";
const $inject = [];

class DefaultDateService {
  constructor() {
  }

  default_date_of_birth() {
    let default_date_of_birth = new Date();
    default_date_of_birth.setDate(1);
    default_date_of_birth.setMonth(0);
    default_date_of_birth.setFullYear(default_date_of_birth.getFullYear() - 60);
    return default_date_of_birth;
  }

  earliest_date_of_birth() {
    let earliest_date_of_birth = new Date();
    earliest_date_of_birth.setFullYear(earliest_date_of_birth.getFullYear() - 120);
    return earliest_date_of_birth;
  }
}

DefaultDateService.$inject = $inject;

export default angular.module(module_name, [])
  .service("DefaultDateService", DefaultDateService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/default-date.service.js
 **/